import {
  Academy_Icon,
  Evaluation_Labelling_Icon,
  Local_Language_Icon,
  Lowcode_Icon,
  Why_Choose_Us_Bg,
} from "../../images";

export default function WhyChooseUsHome() {
  const why = [
    {
      icon: Evaluation_Labelling_Icon,
      title: "Evaluation & Labeling",
      text: "Hybrid human + AI pipelines deliver accurate, audited labels for African contexts.",
    },
    {
      icon: Local_Language_Icon,
      title: "Local Language Intelligence",
      text: "We build African LLMs that make low-resource languages globally usable.",
    },
    {
      icon: Lowcode_Icon,
      title: "Low-Code AI for Developers",
      text: "A platform to build, fine-tune, and deploy AI with minimal engineering lift.",
    },
    {
      icon: Academy_Icon,
      title: "[AI] Academy",
      text: "1,000+ students trained in AI literacy and data operations, creating a workforce ready to label, evaluate, and annotate at scale.",
    },
  ];

  return (
    <section
      className="bg-[#EDF1FF] py-[48px] bg-left-bottom md:bg-center bg-cover md:bg-contain"
      style={{
        backgroundImage: `url("${Why_Choose_Us_Bg}")`,
      }}
    >
      <div className="container space-y-12">
        <div className="mb-20 text-center">
          <h1 className="mb-2 text-2xl md:text-3xl font-bold tracking-tight xl:text-[36px] text-[#FFF]">
            Why Choose Us
          </h1>
          <p className="mx-auto max-w-5xl font-medium text-base text-white">
            Ouilt for Africa, Powered by AI
          </p>
        </div>

        <div className="grid grid-cols-12 gap-y-8 md:gap-8">
          {why.map((item, idx) => (
            <div
              key={idx}
              className="col-span-12 md:col-span-6 xl:col-span-3 bg-white flex flex-col items-center rounded-xl px-3 py-6 gap-4"
            >
              <img
                src={item.icon}
                alt={`${item.title} illustration`}
                className="w-16 h-16"
              />
              <div className="space-y-2 text-center">
                <h5 className="text-lg md:text-xl font-bold text-[#020128]">
                  {item.title}
                </h5>
                <p className="text-sm md:text-base text-[#020128]">
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
